import React from 'react';

const GoalsHeader = () => {
    return (
        <div>
            <h1>Goals</h1>
        </div>
    );
};

export default GoalsHeader;
